const arabicTranslations = {
  mainTitle: "اكتب موجهًا، أطلق عالماً",
  subtitle: "أول رسوم متحركة نص إلى 60 ثانية بدقة 720 بكسل، مثالية للمشاركة مع الأصدقاء!",
  // Text prompt card
  promptTitle: "أدخل عنوان الكتاب",
  promptSubtitle: "ما هي القصة التي تريد أن تبعث فيها الحياة؟",
  bookPlaceholder: "مثال: الحديقة السرية",
  chooseStyle: "اختر النمط",
  // Inspiration feature
  needInspiration: "تحتاج إلى إلهام؟",
  selectGenre: "اختر نوعًا أدبيًا",
  fantasy: "خيال",
  scienceFiction: "خيال علمي",
  mystery: "غموض",
  romance: "رومانسية",
  historicalFiction: "خيال تاريخي",
  getIdea: "احصل على فكرة",
  loadingIdea: "جاري البحث عن إلهام...",
  // Steps
  bookTitle: "عنوان الكتاب",
  style: "النمط",
  email: "البريد الإلكتروني",
  // Style picker
  styleTitle: "اختر نمطك",
  styleSubtitle: "حدد نمط الرسوم المتحركة لإبداعك",
  continueButton: "متابعة",
  backButton: "رجوع",
  // Email checkout
  checkoutTitle: "إبداعك السحري",
  checkoutSubtitle: "أكمل طلبك لإحياء خيالك",
  yourEmail: "بريدك الإلكتروني",
  emailPlaceholder: "you@example.com",
  validationMessage: "يرجى إدخال عنوان بريد إلكتروني صالح",
  orderItem: "فيديو مدته 60 ثانية بنمط {style}",
  deliveryTime: "وقت التسليم:",
  deliveryTimeValue: "45-55 دقيقة",
  total: "المجموع:",
  getAnimation: "الحصول على الرسوم المتحركة",
  securePayment: "دفع آمن تتم معالجته بواسطة Stripe",
  
  // Video carousel
  seeTheMagic: "شاهد السحر في العمل",
  
  // Disclaimer
  disclaimer: "إخلاء مسؤولية: هذه المنصة هي أداة إبداعية مستقلة مصممة للتعبير الفني من خلال استخدام الذكاء الاصطناعي التوليدي. في حين أن المخرجات المرئية أو الموضوعية قد تشبه في بعض الأحيان الأساليب المرئية في وسائل الإعلام الشعبية أو الرسوم المتحركة، إلا أن هذا المنتج غير مرتبط أو معتمد أو متصل بأي استوديو رسوم متحركة أو علامة تجارية ترفيهية أو مالك للملكية الفكرية.",
  originality: "جميع مقاطع الفيديو والصور والشخصيات والمشاهد التي يتم إنشاؤها من خلال هذه المنصة هي إبداعات أصلية، تم إنتاجها باستخدام نماذج الذكاء الاصطناعي والموجهات المقدمة من المستخدمين. نحن لا نستخدم أو ندمج أي شخصيات أو قصص أو أعمال فنية أو صوتية أو أسماء محمية بحقوق النشر من الملكيات الفكرية الموجودة في أي سلوك افتراضي للنظام أو النموذج.",
  intellectualProperty: "جميع حقوق النشر والعلامات التجارية والملكيات الفكرية للغير التي يشار إليها أو يتم استحضارها بشكل غير مباشر من قبل المستخدمين تظل ملكية حصرية لأصحابها.",
  userResponsibility: "المستخدمون مسؤولون وحدهم عن:",
  promptsSubmitted: "الموجهات التي يقدمونها،",
  contentGenerated: "المحتوى الذي يختارون إنشاءه،",
  contentUsage: "وأي استخدام أو توزيع أو نشر ناتج عن مخرجات الذكاء الاصطناعي.",
  liability: "نحن لا نتحمل أي مسؤولية عن أي محتوى يتم إنشاؤه أو إساءة استخدامه أو مشاركته أو توزيعه بطريقة قد تنتهك حقوق الملكية الفكرية أو شروط الخدمة أو القانون المعمول به. هذه المنصة مخصصة فقط لرواية القصص الأصلية والتجريب الفني والمتعة الشخصية."
};

export default arabicTranslations; 